import { getCount } from "@/services/license-tickets/service";

import { NATIONAL, INTERNATIONAL } from "@/common/constants/ticket-types";

const state = () => ({
  ticket: {
    show: false,
    has_tickets: false,
    count: 0,
    is_mixed: false,
    type: null,
    message: null
  }
});

const mutations = {
  SET_DATA(state, data = {}) {
    state.ticket = data;
  }
};
const actions = {
  async getCount({ commit }, data = { has_tickets: 1, ticket_type: NATIONAL }) {
    const { data: response_national } = await getCount(data);
    const { data: response_international } = await getCount({
      has_tickets: 1,
      ticket_type: INTERNATIONAL
    });
    const { data: response_no_ticket } = await getCount({ has_tickets: 0 });
    let sum = 0;
    let message = "";
    if (response_national) {
      const {
        count_tickets: count_tickets_national,
        tickets_type: tickets_type_national
      } = response_national;
      if (count_tickets_national > 0) {
        sum = sum + count_tickets_national;
        const s_p =
          count_tickets_national < 2
            ? {
                permiso: " permiso con tiquete ",
                solicitud: " solicitud"
              }
            : {
                permiso: " permisos con tiquetes ",
                solicitud: " solicitudes"
              };
        message =
          count_tickets_national + s_p.permiso + tickets_type_national + ", ";
        const initial_message =
          "Tienes " +
          count_tickets_national +
          +s_p.solicitud +
          " de permisos con tiquetes " +
          tickets_type_national +
          " sin gestionar," +
          " recuerda que se aprobarán automaticamente si no son gestionadas.";
        commit("SET_DATA", {
          show: true,
          count: count_tickets_national,
          has_tickets: true,
          is_mixed: false,
          type: tickets_type_national,
          message: initial_message
        });
      }
    }
    if (response_international) {
      const {
        count_tickets: count_tickets_international,
        tickets_type: tickets_type_international
      } = response_international;
      if (count_tickets_international > 0) {
        sum = sum + count_tickets_international;
        const s_p =
          count_tickets_international < 2
            ? {
                permiso: " permiso con tiquete ",
                solicitud: " solicitud"
              }
            : {
                permiso: " permisos con tiquetes ",
                solicitud: " solicitudes"
              };
        message =
          message +
          count_tickets_international +
          s_p.permiso +
          tickets_type_international +
          ", ";
        const initial_message =
          "Tienes " +
          count_tickets_international +
          s_p.solicitud +
          " de permisos con tiquetes " +
          tickets_type_international +
          " sin gestionar," +
          " recuerda que se aprobarán automaticamente si no son gestionadas.";
        commit("SET_DATA", {
          show: true,
          count: count_tickets_international,
          has_tickets: true,
          is_mixed: false,
          type: tickets_type_international,
          message: initial_message
        });
      }
    }
    if (response_no_ticket) {
      const {
        count_tickets: count_tickets_nt,
        has_tickets: has_tickets_nt
      } = response_no_ticket;
      if (count_tickets_nt > 0) {
        sum = sum + count_tickets_nt;
        const sp_not_tikect =
          count_tickets_nt < 2
            ? {
                permiso: " permiso sin tiquete. ",
                solicitud: " solicitud"
              }
            : {
                permiso: " permisos sin tiquetes. ",
                solicitud: " solicitudes"
              };
        message = message + count_tickets_nt + sp_not_tikect.permiso;
        const initial_message =
          "Tienes " +
          count_tickets_nt +
          sp_not_tikect.solicitud +
          " de permisos sin tiquetes y sin gestionar," +
          " recuerda que se aprobarán automaticamente si no son gestionadas.";
        commit("SET_DATA", {
          show: true,
          count: count_tickets_nt,
          has_tickets: has_tickets_nt,
          is_mixed: false,
          message: initial_message
        });
      }
    }
    if (sum > 0) {
      const msg =
        "Tienes " +
        sum +
        " permisos sin gestionar, " +
        message.substr(0, message.length - 2) +
        ". Recuerda que se aprobarán automaticamente si no son gestionadas.";
      return commit("SET_DATA", {
        show: true,
        has_tickets: true,
        is_mixed: true,
        type: null,
        message: msg
      });
    }
  }
};
const getters = {
  getterTicket: state => {
    return state.ticket;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
